import React, { useEffect, useState, useMemo, useRef, } from 'react'
import {
    Constants,
    MeetingProvider,
    MeetingConsumer,
    useMeeting,
    useParticipant,
    useWhiteboard
} from "@videosdk.live/react-sdk";
import Chat from './Chat';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { Dropdown } from "react-bootstrap";
import recordingBlink from "./animations/recording-blink.json";
import useIsRecording from "./hooks/useIsRecording"
import { OutlinedButton } from './OutlinedButton';
import RecordingIcon from './RecordingIcon';
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from 'react-redux';
import { postStartRecordingData } from '../../Redux/action/MasterAction';
import MeetingTimer from './MeetingTimer';
import MeetingExtend from './MeetingExtend';
import toast from 'react-hot-toast';
const ConfirmationModal = ({ show, onConfirm, onCancel, message }) => {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Body className="text-center p-4">
                <p className="mb-3">{message}</p>
                <div className="d-flex justify-content-center gap-2">
                    <Button variant="danger" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={onConfirm}>
                        Continue
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};
const Controls = ({ meetingId, user_name, user_type, participantDetails, onMeetingLeave, presenterId, endTime, location }) => {
    const [meetingEndTime, setMeetingEndTime] = useState(endTime);
    const currentTime = new Date();
    const meetingEndTimes = new Date(meetingEndTime);
    const timeDifference = meetingEndTimes - currentTime;
    const { screenShareOn } = useParticipant(presenterId);
    const dispatch = useDispatch()
    // console.log('participantDetails',participantDetails)
    const tutor = localStorage.getItem('tutor-token');
    let [isTutor, setisTutor] = useState(null)

    useEffect(() => {
        if (tutor) {
            const decoded = jwtDecode(tutor);

            if (decoded?.user?.user_type == 'tutor') {
                setisTutor(true);

            }
            else {
                setisTutor(false)

            }

        }
        else {

            setisTutor(false)
        }

    }, [])


    const { end, leave, toggleMic, toggleWebcam, enableScreenShare, disableScreenShare, toggleScreenShare } = useMeeting({
        onMeetingLeft: () => {
            onMeetingLeave();
        },

    });
    const handleToggleScreenShare = () => {
        // Toggling screen share
        toggleScreenShare();
    };
    const [showModal, setShowModal] = useState(false);
    const [showExtendModal, setShowExtendModal] = useState(false);
    const [actionType, setActionType] = useState(""); // "screenShare" or "whiteboard"

    const { startWhiteboard, stopWhiteboard, whiteboardUrl } = useWhiteboard();
    const [micOn, setMicOn] = useState(participantDetails?.micOn);

    const [camOn, setCamOn] = useState(participantDetails?.camOn);
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);
    const navigate = useNavigate();
    const handleLeaveMeeting = () => {
        leave();
        navigate(-1)

    }

    const handleMicToggle = () => {
        setMicOn(!micOn)
        toggleMic()
    }

    useEffect(() => {
        setMicOn(participantDetails?.micOn);
    }, [participantDetails?.micOn]);

    useEffect(() => {
        setCamOn(participantDetails?.camOn);
    }, [participantDetails?.camOn]);


    const handleCamToggle = () => {
        setCamOn(!camOn)
        toggleWebcam()
    }



    const handleEndMeeting = () => {
        console.log('user', user_type)
        end();
        if (user_type == 'tutor') {
            navigate('/tutor/dashboard')
        }
        if (user_type == 'student') {
            navigate('/student/dashboard')
        }
        else {
            navigate(-1)
        }
    }


    const handleAction = (type) => {
        if (screenShareOn && type == "whiteboard") {
            setActionType(type);
            setShowModal(true);
        }
        // else if (type=="screenShare" && whiteboardUrl) {
        //     setActionType(type);
        //     setShowModal(true);
        // }
        else if (type == "screenShare" && !whiteboardUrl) {
            setActionType(type);
            toggleScreenShare()
        }
        // else if (!screenShareOn && type=="whiteboard"){
        //     startWhiteboard();
        //     setActionType(type);
        // }
        else {
            type === "screenShare" ? toggleScreenShare() : startWhiteboard();
        }
    };

    const handleConfirm = () => {
        setShowModal(false);
        actionType === "screenShare" ? toggleScreenShare() : startWhiteboard();
    };

    const handleStopWhiteBoard = () => {
        stopWhiteboard()
        setShowModal(false);
        if (screenShareOn) {
            setActionType("screenShare")
        }
        else {
            setActionType("")
        }
    };



    const RecordingBTN = () => {
        const { startRecording, stopRecording, recordingState } = useMeeting({
            onRecordingStarted: () => {
                // console.log("onRecordingStarted");
            },
            onRecordingStopped: () => {
                // console.log("onRecordingStopped");
            }
        });
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: recordingBlink,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
            },
            height: 64,
            width: 160,
        };

        const isRecording = useIsRecording();

        const isRecordingRef = useRef(isRecording);

        useEffect(() => {
            isRecordingRef.current = isRecording;
        }, [isRecording]);

        const { isRequestProcessing } = useMemo(
            () => ({
                isRequestProcessing:
                    recordingState === Constants.recordingEvents.RECORDING_STARTING ||
                    recordingState === Constants.recordingEvents.RECORDING_STOPPING,
            }),
            [recordingState]
        );

        const _handleClick = async () => {
            const isRecording = isRecordingRef.current;

            const config = {
                layout: {
                    type: "GRID",
                    priority: "SPEAKER",
                    gridSize: 4,
                },
                theme: "DARK",
                mode: "video-and-audio",
                quality: "high",
                orientation: "landscape",
            };

            let transcription = {
                enabled: true,
                summary: {
                    enabled: true,
                    prompt:
                        "Write summary in sections like Title, Agenda, Speakers, Action Items, Outlines, Notes and Summary",
                },
            };

            if (isRecording) {

                stopRecording();
            } else {

                try {
                    startRecording();

                } catch (error) {
                    console.error("Error starting recording:", error);
                }
            }
        };


        return (
            <>
                {/* <button className={`btn btn-secondary mx-1`} title={isRecording?'Stop Recording':'Start Recording'} onClick={_handleClick}>{isRecording?<i class='fa fa-stop' style={{fontSize:'20px'}}></i>:<i class='fas fa-record-vinyl' style={{fontSize:'20px'}}></i>}</button> */}

                <OutlinedButton

                    Icon={RecordingIcon}
                    onClick={_handleClick}
                    isFocused={isRecording}

                    lottieOption={isRecording ? defaultOptions : null}
                    isRequestProcessing={isRequestProcessing} />
            </>
        );
    };

    // pip
    const pipWindowRef = useRef();
    const getRowCount = (length) => {
        return length > 2 ? 2 : length > 0 ? 1 : 0;
    };
    const getColCount = (length) => {
        return length < 2 ? 1 : length < 5 ? 2 : 3;
    };

    const togglePipMode = async () => {
        if (pipWindowRef.current) {
            await document.exitPictureInPicture();
            pipWindowRef.current = null;
            return;
        }
        if ("pictureInPictureEnabled" in document) {

            //Stream playing here
            //Create a Canvas which will render the PiP Stream
            const source = document.createElement("canvas");
            const ctx = source.getContext("2d");

            //Create a Video tag which will popout for PiP
            const pipVideo = document.createElement("video");
            pipWindowRef.current = pipVideo;
            pipVideo.autoplay = true;

            //Create a stream from canvas which will play
            const stream = source.captureStream();
            pipVideo.srcObject = stream;

            //Do initial Canvas Paint
            drawCanvas()

            //When Video is ready, start PiP mode
            pipVideo.onloadedmetadata = () => {
                pipVideo.requestPictureInPicture();
            };
            await pipVideo.play();

            //When the PiP mode starts, draw the canvas with PiP view
            pipVideo.addEventListener("enterpictureinpicture", (event) => {
                drawCanvas();
            });

            //When PiP mode exits, dispose the tracks that were created earlier
            pipVideo.addEventListener("leavepictureinpicture", (event) => {
                pipWindowRef.current = null;
                pipVideo.srcObject.getTracks().forEach((track) => track.stop());
            });

            //This will draw all the video elements in to the Canvas
            function drawCanvas() {
                //Getting all the video elements in the document
                const videos = document.querySelectorAll("video");
                try {
                    //Perform initial black paint on the canvas
                    ctx.fillStyle = "black";
                    ctx.fillRect(0, 0, source.width, source.height);

                    //Drawing the participant videos on the canvas in the grid format
                    const rows = getRowCount(videos.length);
                    const columns = getColCount(videos.length);
                    for (let i = 0; i < rows; i++) {
                        for (let j = 0; j < columns; j++) {
                            if (j + i * columns <= videos.length || videos.length == 1) {
                                ctx.drawImage(
                                    videos[j + i * columns],
                                    j < 1 ? 0 : source.width / (columns / j),
                                    i < 1 ? 0 : source.height / (rows / i),
                                    source.width / columns,
                                    source.height / rows
                                );
                            }
                        }
                    }
                } catch (error) { }

                //If pip mode is on, keep drawing the canvas when ever new frame is requested
                if (document.pictureInPictureElement === pipVideo) {
                    requestAnimationFrame(drawCanvas);
                }
            }

        } else {
            alert("PiP is not supported by your browser");
        }
    };




    useEffect(() => {
        const interval = setInterval(() => {
            const currentTime = new Date();
            const meetingEnd = new Date(meetingEndTime);

            const timeDifference = meetingEnd.getTime() - currentTime.getTime();

            // Show a warning toast 5 minutes before ending
            if (timeDifference <= 5 * 60 * 1000 && timeDifference > 4 * 60 * 1000 && !window.toastShown) {
                toast.success('Meeting will end in 5 minutes.');
                window.toastShown = true;
            }

            // console.log('currentTime', currentTime, "meetingEndTime", meetingEnd);

            // End meeting if time has expired
            if (timeDifference <= 0) {
                clearInterval(interval);
                end();
                toast.error('Meeting Ended');

                if (user_type === 'tutor') {
                    navigate('/tutor/dashboard');
                } else if (user_type === 'student') {
                    navigate('/student/dashboard');
                } else {
                    navigate(-1);
                }
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [meetingEndTime, end]);



    return (
        <>
            <div className="video-controls">
                {(timeDifference <= 5 * 60 * 1000) &&
                    <MeetingTimer endTime={meetingEndTime} />
                }
                <div className="controls-container">
                    <RecordingBTN />

                    {(tutor && isTutor) ? (
                        <Dropdown>
                            <Dropdown.Toggle className="control-btn">
                                <i className="text-danger fas fa-phone-slash"></i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={handleLeaveMeeting}>Leave Call</Dropdown.Item>
                                <Dropdown.Item onClick={handleEndMeeting}>End Meeting For All</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    ) : (
                        <button className="control-btn" onClick={handleLeaveMeeting}>
                            <i className="text-danger fas fa-phone-slash"></i>
                        </button>
                    )}

                    <button className="control-btn" onClick={handleMicToggle}>
                        {micOn
                            ? <i className="fa fa-microphone" title="Mute"></i>
                            : <i className="fa fa-microphone-slash" title="Unmute"></i>}
                    </button>

                    <button className="control-btn" onClick={handleCamToggle}>
                        {participantDetails?.webcamOn
                            ? <i className="fas fa-video" title="Off Camera"></i>
                            : <i className="fas fa-video-slash" title="On Camera"></i>}
                    </button>

                    <button
                        className={`control-btn ${(screenShareOn && (presenterId === participantDetails?.id)) ? 'active' : 'control-btn-invert'}`}
                        onClick={() => handleAction("screenShare")}
                    >
                        {(screenShareOn && (presenterId === participantDetails?.id)) ?
                            <img src="/assets/img/user/share.png" alt="Share" />
                            :
                            <img src="/assets/img/user/share.png" alt="Share" />
                        }
                    </button>
                    <button className="control-btn" onClick={handleAddShow} title="Chat">
                        <i className="far fa-comment-dots"></i>
                    </button>


                    {!whiteboardUrl ? (
                        <button className='btn btn-secondary' style={{ 'border': '2px solid #848884' }} onClick={() => handleAction("whiteboard")}>
                            Start Whiteboard
                        </button>
                    ) : (
                        <button className='btn btn-secondary' style={{ 'border': '2px solid #848884', "zIndex": 2 }} onClick={handleStopWhiteBoard}>
                            Stop Whiteboard
                        </button>
                    )}

                    {user_type == 'tutor' &&
                        <button className="control-btn" onClick={() => setShowExtendModal(true)} title="Extend meeting">
                            <i className="fa fa-info-circle"></i>
                        </button>}

                </div>

            </div>

            {whiteboardUrl &&
                <div style={{ height: '90%', width: '100%', position: 'absolute', top: '0', left: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <iframe className='white-board-area' src={whiteboardUrl} style={{
                        zIndex: 1
                    }}></iframe>
                </div>
            }
            <Chat show={addShow} handleClose={handleAddClose} user_name={user_name} />

            {/* Confirmation Modal */}
            <ConfirmationModal
                show={showModal}
                onConfirm={handleConfirm}
                onCancel={() => setShowModal(false)}
                message="A screen or whiteboard is already being shared. Do you still want to continue?"
            />
            <MeetingExtend
                data={location}
                onExtendSuccess={(newEndTime) => {
                    setMeetingEndTime(newEndTime);
                }}

                show={showExtendModal}
                onCancel={() => setShowExtendModal(false)}
            />
        </>

    );
}

export default Controls
